import { z } from "zod";

export const ParadexConnectionStatus = {
  ONLINE: "online",
} as const;
export type ParadexConnectionStatus = (typeof ParadexConnectionStatus)[keyof typeof ParadexConnectionStatus];

export const AddParadexAccountSchema = z.object({
  accountId: z.number().int().positive(),
  walletAddress: z.string().min(1),
  status: z.string(),
});
export type AddParadexAccountDto = z.infer<typeof AddParadexAccountSchema>;
